// import ls from "local-storage";
import axios from "axios";
import { decamelizeKeys } from "humps";

const API = "heal.api";

class BaseService {
  static apiUrl() {
    let api = process.env.VUE_APP_API_URL;
    if (window.location.hostname.match(/\./)) {
      const subdomain = window.location.hostname.split(".")[0] || "public";
      api = api.replace("public", subdomain);
    }
    return api;
  }

  static get(url) {
    return this.request("get", url);
  }

  static post(url, data) {
    return this.request("post", url, data);
  }

  static patch(url, data) {
    return this.request("patch", url, data);
  }

  static request(requestType, url, data = null) {
    return axios[requestType](`${this.apiUrl()}/v1/schedule/${url}`, data);
  }
}

export default BaseService;
